// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Engagement } from "../../../data/talent-core/engagement";
import { EnvelopeDocument } from "../base/envelope-document";

export class EngagementDocument extends EnvelopeDocument {
	public override Item: Engagement = new Engagement();
}